import Footer from '../components/Footer/Footer';
import Copilot from '../Copilot/Copilot'; /* eslint-disable */
import React from 'react';
import { transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".billing-option").click(function(){$(".billing-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".bl-p-section").removeClass("active"),$(".bl-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".usage-option").click(function(){$(".usage-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".u-p-section").removeClass("active"),$(".u-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".cpc-tr").click(function(){$(".cpc").show().delay(1e3).fadeOut()}),$(".user-dots").on("click",function(){$(this).toggleClass("active")}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-skills-v7.webflow.io");$(this).attr("href",e)}),$(".submit-prompt").click(function(){$(".human-text").removeClass("hide"),setTimeout(function(){$(".s1")[0].style.display="flex"},1e3),setTimeout(function(){$(".s2")[0].style.display="flex"},2e3)}),$(".skills-option").click(function(){var e=$(this).attr("data-name");$(".skills-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$("html, body").animate({scrollTop:$(".scroll-div[data-name="+e+"]").offset().top-79},1e3)}),$(".item_options").each(function(){$(this).mouseover(function(){var e=$(this).closest("a").attr("href");$(this).closest("a").removeAttr("href"),$(this).closest("a").data("default_url",e)}),$(this).mouseout(function(){$(this).closest("a").data("default_url")&&$(this).closest("a").attr("href",$(this).closest("a").data("default_url"))}),$(this).click(function(){0<$(this).closest(".w-slider-mask").length&&($(this).closest(".w-slider-mask")[0].style.overflow="visible",$(".sl_c").css("z-index","auto"),$(this).closest(".sl_c")[0].style.zIndex="5",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="hidden"}),$(this).closest(".w-slide")[0].style.visibility="visible"),$(".options_div").each(function(e){$(this)[0].style.display="none"}),$(this).find(".options_div").toggle()})}),$(".item_options").click(function(e){e.stopPropagation()}),$(window).click(function(){$(".options_div").each(function(e){$(this)[0].style.display="none",0<$(this).closest(".w-slider-mask").length&&($(this).closest(".sl_c")[0].style.zIndex="auto",$(this).closest(".w-slider-mask")[0].style.overflow="hidden",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="visible"}))})}),$(".mobile_nav_trigger").click(function(){"block"!=$(".mobile_nav")[0].style.display?$(".mobile_nav")[0].style.display="block":$(".mobile_nav")[0].style.display="none"}),$(window).click(function(){$(".mobile_nav")[0].style.display="none"}),$(".mobile_nav").click(function(e){e.stopPropagation()}),$(".mobile_nav_trigger").click(function(e){e.stopPropagation()}),$(".link-options-2").click(function(){var e=$(this).attr("data-name");$(".link-options-2").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(e){$(this).removeClass("active")}),$(".panel[data-name="+e+"]").addClass("active")}),$(".open-chat").click(function(){$(".chatbox").addClass("open"),$(".ch_c").removeClass("hidden")}),$(".minimize").click(function(){$(".chatbox").removeClass("open"),$(".ch_c").addClass("hidden")}),$(".div-block-163").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(".div-block-167").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(window).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"})}),$(".div-block-163").click(function(e){e.stopPropagation()}),$(".div-block-167").click(function(e){e.stopPropagation()}),$(".br_menu").click(function(){$(".br_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".browse_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.browse_panel[data-name="\'+e+\'"]\')[0].style.display="flex"}),$(".f_row").each(function(){$(this).click(function(){$(this).find(".img_v").toggle(),$(this).find(".img_h").toggle(),$(this).next().toggle()})}),$(".f_box .text-field.w-input").each(function(){$(this).keyup(function(){let i=$(this).val();var e=$(this).parent().parent().find(".checkbox-field");$(e).each(function(e){0<=$(this).find(".checkbox-label")[0].innerHTML.toLowerCase().indexOf(i.toLowerCase())?$(this)[0].style.display="block":$(this)[0].style.display="none"})})}),$(".feed-option").click(function(){$(".feed-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".feed_cont").each(function(e){$(this).removeClass("active")}),$(\'.feed_cont[data-name="\'+e+\'"]\').addClass("active"),"messages"==e||"following"==e||"followers"==e?$("body").addClass("messages_active"):$("body").removeClass("messages_active")});var e=window.location.href,e=(console.log(e),e.split("#")[1]);function i(){$(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"),$(".tw_r.new_m_user").each(function(e){$(this).removeClass("active")})}e&&(e=document.querySelector(\'.prof_menu[data-name="\'+e+\'"]\'))&&e.click(),document.getElementById("pink0").oninput=function(){var e=(this.value-this.min)/(this.max-this.min)*100;this.style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+e+"%, #fff "+e+"%, white 100%)"},$("input[type=range]").on("input",function(){var t=$(this).attr("data-index"),l=$(this).val();$("#i"+t).html(l);{let i=0;$(".is-pink0").each(function(e){0<$(this).val()&&(i+=1)}),console.log(i),$("#rs").html(i),3==i?($(".skills_allow")[0].style.display="flex",$(".skills_next0").hide()):($(".skills_allow").hide(),$(".skills_next0").show())}{let e="",i="";0==l?(e="NOT RATED",i="0"):1==l?(e="BEGINNER",i="10px"):2==l?(e="NOVICE",i="60px"):3==l?(e="INTERMEDIATE",i="80px"):4==l?(e="ADVANCED",i="130px"):5==l&&(e="EXPERT",i="160px"),$(".level-text")[t].style.marginLeft=i,$(".level-text")[t].innerHTML=e}l=$(this)[0],t=(l.value-l.min)/(l.max-l.min)*100;$(this)[0].style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+t+"%, #e9eaeb "+t+"%, #e9eaeb 100%)"}),$(".is-pink0").on("touchstart",function(e){}),$(".is-pink0").on("touchend",function(){}),$(".more").click(function(){$(this).hide(),$(".link-block-7").each(function(e){$(this).removeClass("hide")})}),$(".down_arr").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$(".skills_next0.disabled").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills-v2.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$(".c-block").click(function(){$(".cm_popup_div")[0].style.display="flex"}),$(".comment-c").click(function(){$(".cm_popup_div")[0].style.display="none"}),$(".tw-img-trigger").click(function(){$("#tw-img-uploader").trigger("click")}),$(".likes_tab").click(function(){$(".likes_tab").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".profile_text").each(function(e){$(this).removeClass("active")}),$(\'.profile_text[data-name="\'+e+\'"]\').addClass("active"),$(".profile_list").each(function(e){$(this).removeClass("active")}),$(\'.profile_list[data-name="\'+e+\'"]\').addClass("active")}),$(".message_div .tw_r").click(function(){$(".message_div").addClass("mobile_hidden"),$(".chat_div").removeClass("mobile_hidden")}),$(".show_msg_div").click(function(){$(".message_div").removeClass("mobile_hidden"),$(".chat_div").addClass("mobile_hidden")}),$(".follow_tab").click(function(){var e=$(this).attr("data-name");e&&$(\'.feed-option[data-name="\'+e+\'"]\').click()}),$(".follow_tabs_back").click(function(){$(\'.feed-option[data-name="home"]\').click()}),$(".create-group").click(function(){$(".create_group_popup").removeClass("hidden"),$(".new_message_popup").addClass("hidden")}),$(".back_dc").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden")}),$(".cancel_user.c_i").click(function(){i()}),$(".next_form.n_m.next").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden"),$(this).hasClass("disabled")||($(".nm_popup")[0].style.display="none",i())}),$(".new_message").click(function(){$(".nm_popup")[0].style.display="flex"}),$(".tw_r.new_m_user").each(function(e){$(this).click(function(){$(this).toggleClass("active");let i=!1;$(".tw_r.new_m_user").each(function(e){$(this).hasClass("active")&&(i=!0)}),i?($(".n_m.next").removeClass("disabled"),$(".create-group").addClass("hide"),$(".group-users").addClass("show")):($(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"))})}),$(".div-block-181").each(function(e){$(this).click(function(){$(this).find(".div-block-193").toggle()})}),$(".cancel_type_popup").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".cancel_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".add_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".div-block-176").each(function(e){$(this).click(function(){$(".add_content_popup")[0].style.display="none",$(".type_content_popup")[0].style.display="block"})}),$(".content_menu").click(function(){$(".content_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".conent_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.conent_panel[data-name="\'+e+\'"]\')[0].style.display="block","type"==e?$(".add_content_btn").addClass("disabled"):$(".add_content_btn").removeClass("disabled")}),$(".add_content_div").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_content_popup")[0].style.display="block"})}),$(".add_content_btn").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_content").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_popup").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".dc").click(function(){$(".popup_div")[0].style.display="flex",$(".body")[0].style.overflow="hidden",$(".dc_popup")[0].style.display="block"}),$(".cancel_dc").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_dc_div").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_profile_trigger").click(function(){$(".popup_div")[0].style.display="flex",$(".edit_profile_pop")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".cancel_edit_profile").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_edit_prof").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".save_profile_info").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_rating").click(function(){$(".skill_report_popup")[0].style.display="none",$(".rate_skill_popup")[0].style.display="block"}),$(".rate_skill_close").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".cancel_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".confirm_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".skill_box").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".skill_report_popup").toggle()})}),$(".cancel_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".confirm_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".add_skill").click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_skill_popup").toggle()}),$(".confirm_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".cancel_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".dash_nav_item").click(function(){$(".dash_nav_item").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this)[0].innerHTML;$(".panel").each(function(e){$(this)[0].style.display="none"}),$(".panel-"+e.toLowerCase())[0].style.display="flex"}),window.location.hash.substr(1)&&(console.log("fires"),e=window.location.hash.substr(1),$(\'.prof_menu[data-name="\'+e+\'"]\').click());e=new URL(window.location.href).searchParams.get("s");console.log(e),e&&$(\'.prof_menu[data-name="\'+e+\'"]\').trigger("click")}),jQuery.fn.onPositionChanged=function(t,e){null==e&&(e=100);var l,o,s=$(this[0]);return s.length<1||(o=l=null,setInterval(function(){if(null==s||s.length<1)return s;null==l&&(l=s.position()),null==o&&(o=s.offset());var e=s.position(),i=s.offset();l.top==e.top&&l.left==e.left||($(this).trigger("onPositionChanged",{lastPos:l,newPos:e}),"function"==typeof t&&t(l,e),l=s.position()),o.top==i.top&&o.left==i.left||($(this).trigger("onOffsetChanged",{lastOff:o,newOff:i}),"function"==typeof t&&t(o,i),o=s.offset())},e)),s},$(window).on("scroll",function(){$(window).scrollTop()+$(window).height()==$(document).height()?$(".down_arr").hide():$(".down_arr").show()});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '$(document).ready(function(){var t=$("#email-form-4"),e=$("<div>").append(t.contents()),t=(t.replaceWith(e),$(".div-block-276.second .form-2")),e=$(\'<div class="second-input">\').append(t.contents());t.replaceWith(e)}),$(".ask-input").keydown(function(t){13==t.which&&""!=$(".ask-input").val()&&$(".div-block-305.fire-f").trigger("click")}),$(".form-block-8").removeClass("w-form"),$(".close-box").click(function(){$(".body").removeClass("chat-active")}),$(".div-block-305.fire-f").click(function(t){var e,o,s;""!=$(".ask-input").val()&&($(".div-block-276.first")[0].style.display="none",$(".div-block-276.second")[0].style.display="flex",e=0,o="Quantum computing is a field that aims to develop computers that use the principles of quantum physics to perform computations.",s=20,setTimeout(function t(){var i,n;$(".history").removeClass("hidden"),e<o.length?($(".text-block-187")[0].innerHTML+=o.charAt(e),e++,s=Math.floor(15*Math.random())+1,setTimeout(t,s)):($(".text-block-187")[0].classList.add("no-after"),i=0,n="One of the most important concepts in quantum computing is superposition, which allows qubits to be in multiple states simultaneously.",setTimeout(function(){$(".text-block-187")[1].style.display="block",function t(){var e,o;i<n.length?($(".text-block-187")[1].innerHTML+=n.charAt(i),i++,s=Math.floor(10*Math.random())+1,setTimeout(t,s)):($(".text-block-187")[1].classList.add("no-after"),$(".reg-btn").removeClass("hidden"),$(".sources").removeClass("hidden"),$(".related").removeClass("hidden"),$(".reg").addClass("reg-show"),$(".new-chat-text").html(""),$(".new-chat-text").addClass("with_blink"),e=0,o="Quantum computing",setTimeout(function(){$(".text-block-169")[1].style.display="block",function t(){$(".div-block-325").addClass("rel"),e<o.length?($(".new-chat-text")[0].innerHTML+=o.charAt(e),e++,s=Math.floor(100*Math.random())+4,setTimeout(t,s)):$(".new-chat-text").removeClass("with_blink")}()},1e3))}()},10))},2e3))});'
    ),
    isAsync: false,
  },
];

let Controller;

class VideoView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/VideoController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = VideoView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '6596e21ac435cac3c66baaf0';
    htmlEl.dataset['wfSite'] = '6596e21ac435cac3c66baad8';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      VideoView.Controller !== VideoView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-skillspro-v3.webflow.css);


            .full.w-bar .right-content {
              display: flex !important;
              flex-direction: column !important;
          }
            @media screen and (min-width: 768px)  and  (max-width: 1090px){
              .div-block-19.cert-grid{
                  grid-template-columns: 1fr;
              }
          }
            .pr-text:after, .pr-text-2:after, .pr-text-3:after, .pr-text-4:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .div-block-346{
            	border-radius:2px;
            }
            .up{
            	white-space: nowrap;
            }
            .text-block-189{
            	margin-bottom:15px;
            }
            .div-block-345.u-p-section, .div-block-345.bl-p-section{
            	padding-top:15px !important;
            }
            .div-block-352.three-dots-menu{
            	height:132px !important;
            }
            .text-block-203{
            	margin-bottom:15px;
            }
            .div-block-357{
            	padding-bottom:12px;
            }
            .form-block.s_skill.r-search.s-r.search-admin{
            	margin-bottom:15px;  
            }
            .div-block-345.bl-p-section{
              	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .div-block-345.d-p-section{
            	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .cpc{
             margin-top:4px !important;
            }
            .user-dots.active{
              background-color: #f7f9fd;
          }
            .d-admin-m{
              height: 36px !important;
              width:152px !important;
          }
            .user-dots.active .d-admin-m{
              display:block; 
          }
            .pm-33{
            	height: 100%;
              display: flex;
              flex-direction: column;
            }
            .pm-272{
            	display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
            .div-block-358{
            	    flex-grow: 1;
                  align-items: start;
            }
            .chat-box.logged-in.jc-start{
            	justify-content:start !important;
            }
          @media only screen and (max-width: 767px) {
              .text-block-167.new-chat-text, .text-block-186,  .text-block-184, .text-block-169 , .text-field-11.ask-input, .all,
              .text-block-192, .rel-answer.open .answer-text, .text-block-189, .textarea-2, .w_i, .create-text, .add-text,
              .rec-h, .text-field.n_text.s-f, .text-block-167.add-resource, .text-block-199, .text-field-12, .text-block-159-train, .text-block-196,
              .text-block-198, .text-block-160, .div-block-340-train .link-options-train, .text-block-165-tr, .text1-tr, .paragraph-tr, .text-block-163-tr, .text-block-86-tr,
              .text-block-86-tr, .instructor-name-train, .instructor-subtitle-train, .instructor-school-train, .text-block-165-train, .text-block-26, 
              .text-block-197, .test-name-3, .text-block-86, .text-block-120, .text-block-86, .question-title-te
              {
                  font-size: 16px !important;
              }
                .instructor-img-train{
                  width: 70px !important;
                  height: 70px !important
              }
              .text-block-191, .text-block-190, .b-link{
                  font-size:14px;
              }
              .image-45{
                  height:18px;
              }
              .content-2.r-hide{
                  padding-bottom:14px !important
              }
              .text-block-16.p, .text-block-124{
                  font-size:13px;
              }
          }
            @media only screen and (max-width: 767px) {
              .sign-in-panel {
              	padding-top:49px;
              }
              .chat-box-sign-in.hidden.open{
              border:none !important;
                height: auto !important;
              }
            }
            .chat-box-sign-in.hidden.open{
            	height:auto;
              padding-bottom:12px;
          	    	    margin-right:0;
              height:100%;
            }
            .or-3-copy{
            	text-align:center;
            }
            .chat-box-sign-in.hidden{
            	    border: 1px solid #dde1e6 !important;
            }
            .chat-1 .content-2{
            	padding-bottom:0 !important;
            }
            .div-block-305:hover {
              background-color: #fff;
          }
            .related_f{
            	display:none;
            }
            .sources_f{
            	display:none;
            }
            .create-div .text-field{
            	width: 100%;
            }
            .add_content_popup .div-block-333{
            	flex: inherit !important;
            }
            .b-link:hover{
            	text-decoration: underline;
            }
            .div-block-347{
            	padding:10px;
              z-index: 2222;
            }
            .b-link{
            	margin-right:6px !important;
            }
            .div-block-262.last{
            	padding-bottom:3px;
            }
            .about_p_popup_resource .about-box-train .faq-question-wrap-2{
              margin-bottom:0;
            }
              .about_p_popup_resource .faq-question-bar-2{
              padding-bottom:0;
            }
            .link-options-train.link-options:hover{
            	border-bottom: 2px solid #6cafe1;
            }
            .about-box-train .text-block-120{
            	    color: #6cafe1;
            }
            .question-title-te, .test-name-3{
             color: #6cafe1;
            }
            .link-options-train{
            	padding-right:0 !important;
            }
            .div-block-340-train{
            	padding-bottom:5px;
            }
            .about-box-train .faq-question-wrap-2{
            	padding-bottom:0;
            }
            .about-vox-train .accordion__title__faq-2{
            	padding:10px !important;
            }
            .about-box-train .div-block-270{
             padding:10px;
            }
            .link-options-train{
            	font-size:14px !important;
            }
            .rec-h{
            	height:40px;
            }
            .outcome-train .image-118{
            	width:16px;
              height:16px;
            }
            .div-block-333{
            	overflow:hidden;
            }
            .outcome-train .skill-div-2{
            	margin-bottom:5px;
              float:left !important;
              clear:both;
            }
            .outcome-train{
            	overflow:hidden;
            }
            .textarea-2{
            	height:250px !important;
              border-radius: 6px;
            }
            .text-block-187-sum:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .chat-1.hidden{
            	display:none;
            }
            .div-block-272{
            	z-index: 222;
            }
            .div-block-329{
            	max-width:350px;
            }
            .chat-box.hidden{
            	flex-grow: 1;
            }
            .chat-box.hidden.h-auto{
            	height: auto !important;
            }
            .rel-answer.open .answer-text{
            	display:block;
            }
            .right-content {
            	    max-height: 100vh;
              overflow: auto;
            }
            .div-block-325.rel{
            	padding-top:14px;
            }
            .h-hide{
            	display:none !important;
            }
            .all .grow-flex{
            	    overflow: auto;
            }
            .rec-div:hover .div-block-332{
              display: block;
          }
            @media screen and (max-width: 767px) {
              .all .grow-flex{
                  max-height: 89vh;
              }
          }
          /* .all .div-block-325.rel{
              position:absolute !important;
          } */
                .div-block-294-open:hover > .hidden-img{
              display:none;
          }
          .div-block-294-open:hover > .hidden-img-rot{
              display:block;
          }
            .rel-answer.open .answer-text{
              height: auto;
              margin-bottom:10px;
          }
            .div-block-294:hover > .image-116{
              display:none;
          }
          .div-block-294:hover > .image-93-rot{
              display:inline-block;
          }
            .rel-row.open .div-block-294{
              display:none;
          }
          .rel-row.open .div-block-294-open{
              display:inline-block;
          }
            .chat-response .form-2{
            	height:40px;
            }
            .chat-box.hidden{
            	height:100% !important;
            }
            .graphs-row{
                	overflow: auto !important;
            }
            .second-input{
            	display:flex;
              align-items:center;
            }
            	@media screen and (max-width: 767px) {
                    .html-embed-2.skill-point.dblock.w-embed.w-script{
                  overflow: auto !important;
                min-width: 600px !important;
              }
                    .reg-show{
                  display: block;
              }
              .form-block-8{
                  padding-top: 0;
              }
                	    .div-block-280{
                  display: none;;
              }
                	    .div-block-272{
                  position: fixed;
                  top: 0;
                  width: 100%;
                  background: #fff;
              }
              .div-block-52{
                  padding-top: 59px;
              }
                	    .chat-2{
                  position: fixed;
                  bottom: 0;
                  width: 100%;
                  background: #fff;
                                margin-bottom: 0;
                  padding-bottom: 14px;
              }
                    .content-2{
                  padding-bottom:100px;
              }
                	    .full.w-bar .chat-box.hidden{
                  border-radius: 0;
                  border: none !important;
              }
                	    .body.chat-active{
                  overflow: hidden;
              }
             .full.w-bar .image-106.right{
                  padding-right:13px;
              } 
              .div-block-325{
                  position: fixed !important;
                  background: #fff;
                  padding-top:12px;
                        margin-left: 0;
                  margin-right: 0;
                        padding-left: 10px;
                  padding-right: 10px;
              }
              .grow-flex{
                  padding-bottom: 66px;
              }
              .full.w-bar .right-content{
                  width: 100% !important;
                        overflow: auto;
                        padding: 0;
              }
              .chat-box{
                  min-height: auto;
                  height:auto;
                  flex-grow: 1;
              }
              .mob-grid{
                  margin-left: auto;
                  margin-right: auto;
              }
              .resize-img{
                  display: none;;
              }
                    .div-block-326{
                  min-width: auto !important;
              }
            }
              @media screen and (max-width: 390px) {
              .div-block-275{
                  margin-right: 8px;
              }
          }
              .with_blink:after{
            	-webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
              color: #21232e;
            }
            	  .no-after:after{
            	content:\"\" !important;
            }
            @keyframes blink {
            0% {
              display: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          /* Apply the animation to an element */
          .blink {
            animation: blink 1s ease-in-out infinite;
          }
          .text-block-187:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .full.w-bar .p_menu {
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
              .chat-box.active.hidden{
            	border-radius: 4px;
            }
          .full.w-bar .right-content{
              display: flex !important;
              flex-direction: column !important;
          }
            .full.w-bar .image-116.right .sm{
              margin-left: auto;
          }
            .full.w-bar .chat-box.hidden{
              display: flex;
          }
            .full.w-bar .p_menu.w_bar{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            .full.w-bar .panels_cont{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            	.full.w-bar .main-content{
              padding-right:380px;
          }
            .full.w-bar .right-content{
              display: block;
          }
          .full.w-bar .right-content{
              width:380px;
          }
            .chat-box{
            	width:auto !important;
              border: 1px solid #dde1e6 !important;
            }
            .about-panels{
              min-height: calc(100vh - 79px - 59px);
          }
          @media screen and (max-width: 767px)  and (min-width: 480px){
            .chatbox.open .open-chat{
              display: none;
            }
            .ch_c{
              margin-bottom: 0;
            }
          }
            .chatbox {
            padding-bottom: env(safe-area-inset-bottom);
                padding-top: env(safe-area-inset-top);
          }
              .about-body{
            	  min-height: calc(100vh - (79px + 58px))
            }
            input[type=range] {
            border-radius: 8px;
            height: 7px;
            outline: none;
            transition: background 450ms ease-in;
            -webkit-appearance: none;
          }
            .fs-rangeslider_track{
            	pointer-events: none;
            }
            .is-pink{
            	    pointer-events: auto;
            }
            .menicon{
            	    -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #4a78b8, #6cafe1);
            }
            .messages_active .al-m.active {
            margin-bottom: 0;
          }
            .tw_r.new_m_user.active .user_tick{
            display: block;
          }
            .body.messages_active .panels{
            padding-bottom: 0;
          }
          .body.messages_active .panels_cont{
          padding-bottom: 0;
          }
            .feed-option.active .tw_t{
            font-weight: 500;
          }
              ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(0,0,0,0.2);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(0,0,0,0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0,.9);
          }
            .add_content_btn.disabled{
            	opacity:0.7;
            }
            .text-block-16{
            overflow-wrap: break-word;
            }
            @media screen and (max-width: 1231px) {
          .results{
            grid-template-columns: 1fr 1fr;
          }
          }
            .inner span {
           	position: relative;
              top:2px;
            }
            .s_box{
                appearance: none;
              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e\");
              background-repeat: no-repeat;
              background-position: right 7px center;
              background-size: 1em;
            }
              @media screen and (max-width: 479px) {
          .results{
            grid-template-columns: 1fr;
          }
          }
          @media screen and (max-width: 1250px) and (min-width: 991px) {
            .slider.w-slider .link-block-7:last-child{
              display: none;
            }
            .div-block-42.sl{
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
            .div-block-78{
            	min-height: calc(100vh - 78px - 70px);
            }
            @media screen and (max-width: 479px) {
           .div-block-78{
            	min-height: calc(100vh - 78px - 101px);
            }
          }
            <style>
            .wday, .month{
            fill: #6d717f;
          }
          .float-right{
            color: #6d717f;
          }
            .more:hover {
                  background-color: #fff;
              background-image: none !important;
          }
            @media screen and (max-width: 479px){
              .dots{
              	    left: calc(50% - 19px);
              }
            }
            	  .chat-box.hidden{
            	height: auto !important;
            }
            @media screen and (max-width: 767px) {
              .chat-box.hidden{
                  height: 100% !important;
              }
                  .full.w-bar .main-content{
                  display:none;
              }
          }
            .chat-2{
            	padding-top: 14px;
            }
            .chat-box.logged-in.hidden{
            	display:none;
            }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="full">
              <div className="main-content">
                <div className="div-block-326">
                  <div className="nav">
                    <div className="l-nav">
                      <div className="p_menu">
                        <a className="w-inline-block" href="index.html">
                          <img
                            alt=""
                            className="image"
                            loading="lazy"
                            src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                          />
                        </a>
                        <div className="div-block-231">
                          <a className="dash_nav_item" href="index.html">
                            Home
                          </a>
                          <a className="dash_nav_item" href="activity.html">
                            Profile
                          </a>
                          <a className="dash_nav_item" href="social.html">
                            Social
                          </a>
                          <a className="dash_nav_item" href="recommended.html">
                            Recommended
                          </a>
                          <a className="dash_nav_item" href="browse.html">
                            Discover
                          </a>
                        </div>
                        <div className="prof_menu hidden" data-name="feed">
                          Feed
                        </div>
                        <div className="nav-right">
                          <div className="div-block-170">
                            <div className="form-block w-form">
                              <form
                                className="form"
                                data-name="Email Form"
                                data-wf-element-id="460249b8-286b-e7d3-b08e-467251876b8d"
                                data-wf-page-id="6596e21ac435cac3c66baaf0"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block">
                                  <img
                                    alt=""
                                    className="image-2"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field n_text w-input"
                                  data-name="Email 8"
                                  id="email-8"
                                  maxLength={256}
                                  name="email-8"
                                  placeholder="Search"
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="div-block-163-copy pl_s">
                              <img
                                alt=""
                                className="image-3 plus_img"
                                loading="lazy"
                                src="images/plus-2_1plus-2.png"
                              />
                              <img
                                alt=""
                                className="image-3h"
                                loading="lazy"
                                src="images/629f2ca4ae5641d483147dd9_bell.png"
                              />
                              <div className="div-block-164">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Notifications
                                  </div>
                                </div>
                                <div className="div-block-166">
                                  <div className="text-block-105">
                                    There are no new notifications
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="div-block-163"
                              data-w-id="460249b8-286b-e7d3-b08e-467251876b97"
                            >
                              <img
                                alt=""
                                className="image-3"
                                loading="lazy"
                                src="images/bell.png"
                              />
                              <img
                                alt=""
                                className="image-3h"
                                loading="lazy"
                                src="images/629f2ca4ae5641d483147dd9_bell.png"
                              />
                              <div className="div-block-164">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Notifications
                                  </div>
                                </div>
                                <div className="div-block-166">
                                  <div className="text-block-105">
                                    There are no new notifications
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-167">
                              <img
                                alt=""
                                className="image-4"
                                loading="lazy"
                                src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                              />
                              <img
                                alt=""
                                className="image-5"
                                loading="lazy"
                                src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                              />
                              <div className="div-block-164 profile">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Ashley Miller
                                  </div>
                                  <div className="text-block-104 em">
                                    ashley@gmail.com
                                  </div>
                                </div>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="public-profile.html"
                                >
                                  <div className="text-block-106">Profile</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Settings</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Log Out</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mobile_nav_trigger">
                          <div className="menicon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mobile_nav">
                    <div className="mob_nav">
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="index.html">
                          Home
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="activity.html">
                          Profile
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="social.html">
                          Social
                        </a>
                      </div>
                      <div className="div-block-171 last">
                        <a className="dash_nav_item" href="browse.html">
                          Browse
                        </a>
                      </div>
                    </div>
                    <div className="mob_nav">
                      <div className="form-block mobile w-form">
                        <form
                          className="form"
                          data-name="Email Form"
                          data-wf-element-id="b2efde03-044e-57a6-d05f-15b1deb01545"
                          data-wf-page-id="6596e21ac435cac3c66baaf0"
                          id="email-form"
                          method="get"
                          name="email-form"
                        >
                          <div className="div-block">
                            <img
                              alt=""
                              className="image-2"
                              loading="lazy"
                              src="images/magnifying-glass_1magnifying-glass.png"
                            />
                          </div>
                          <input
                            className="text-field n_text w-input"
                            data-name="Email 7"
                            id="email-7"
                            maxLength={256}
                            name="email-7"
                            placeholder="Search"
                            required=""
                            type="email"
                          />
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                      <div className="div-block-172">
                        <div
                          className="div-block-163"
                          data-w-id="b2efde03-044e-57a6-d05f-15b1deb01550"
                        >
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            src="images/bell.png"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/629f2ca4ae5641d483147dd9_bell.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Notifications
                              </div>
                            </div>
                            <div className="div-block-166">
                              <div className="text-block-105">
                                There are no new notifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="div-block-163"
                          data-w-id="b2efde03-044e-57a6-d05f-15b1deb0155a"
                        >
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            sizes="(max-width: 479px) 100vw, (max-width: 767px) 22px, 100vw"
                            src="images/setting.png"
                            srcset="images/setting-p-500.png 500w, images/setting.png 512w"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/62a1d584bc8cea2ba5c40d38_setting-p-500.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">Settings</div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="https://ibl-skills.webflow.io/profile#pp"
                            >
                              <div className="text-block-106">
                                Profile Settings
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="div-block-167">
                          <img
                            alt=""
                            className="image-4"
                            loading="lazy"
                            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                          />
                          <img
                            alt=""
                            className="image-5"
                            loading="lazy"
                            src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                          />
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="activity.html"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="public-profile.html"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="main">
                      <div className="div-block-146">
                        <div className="cover">
                          <div className="c_over"></div>
                          <div className="container-widgets-cover">
                            <div className="div-block-144">
                              <div className="left-col">
                                <div className="name-desc">
                                  <div className="cover-desc">
                                    Learn Python in 5 Minutes
                                  </div>
                                  <div className="cover-heading">
                                    In this video we'll be learning as much
                                    Python as we can in 5 minutes
                                  </div>
                                </div>
                                <div className="div-block-142">
                                  <div className="author-org">
                                    <div className="instructors ins">
                                      <div className="div-block-130">
                                        <div className="div-block-125 ins">
                                          <img
                                            alt=""
                                            className="image-65"
                                            sizes="(max-width: 1439px) 35px, (max-width: 1919px) 2vw, 35px"
                                            src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                            srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                                          />
                                        </div>
                                        <div className="div-block-137">
                                          <div className="text-block-88">
                                            Ann-Marie Rice, Phd +2 more
                                            instuctors
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="offered_by">
                                    <div className="org">
                                      <div className="org-div">
                                        <img
                                          alt=""
                                          className="image-59"
                                          sizes="130px"
                                          src="images/university-logo-small-vertical-white-87a5d6072d.png"
                                          srcset="images/university-logo-small-vertical-white-87a5d6072d-p-500.png 500w, images/university-logo-small-vertical-white-87a5d6072d.png 913w"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="right-col">
                                <div className="div-block-128">
                                  <div className="vid-header w-clearfix">
                                    <div>
                                      <div
                                        className="video w-video w-embed"
                                        style={{
                                          paddingTop: '56.17021276595745%',
                                        }}
                                      >
                                        <iframe
                                          allowfullscreen=""
                                          className="embedly-embed"
                                          scrolling="no"
                                          src="https://cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FI2wURDqiXdM%3Fstart%3D1%26feature%3Doembed%26start%3D1&amp;display_name=YouTube&amp;url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DI2wURDqiXdM&amp;image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FI2wURDqiXdM%2Fhqdefault.jpg&amp;key=96f1f04c5f4143bcb0f2e68c87d65feb&amp;type=text%2Fhtml&amp;schema=youtube"
                                          title="Learn PYTHON in 5 MINUTES"
                                        ></iframe>
                                      </div>
                                    </div>
                                    <a className="button w-button" href="#">
                                      WATCH THIS VIDEO
                                    </a>
                                  </div>
                                  <div className="div-block-145">
                                    <div className="w-layout-grid features video">
                                      <div className="div-block-129">
                                        <div className="faq-wrap">
                                          <img
                                            alt=""
                                            className="img-trg-2"
                                            sizes="(max-width: 479px) 23px, (max-width: 767px) 26px, (max-width: 991px) 3vw, (max-width: 1279px) 27px, (max-width: 1439px) 2vw, (max-width: 1919px) 27px, 1vw"
                                            src="images/62a9b652cf37c515a7973c54_dol.png"
                                            srcset="images/62a9b652cf37c515a7973c54_dol-p-500.png 500w, images/62a9b652cf37c515a7973c54_dol.png 594w"
                                          />
                                        </div>
                                        <div className="features_block">
                                          <div className="features-title price">
                                            Free
                                          </div>
                                          <div className="features-description">
                                            Price
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-129">
                                        <div className="faq-wrap">
                                          <img
                                            alt=""
                                            className="img-trg-2"
                                            src="images/62a9b652cf37c5ffb1973c47_5ea1c3c106d5f85a5f2776db_clock-p-500.png"
                                          />
                                        </div>
                                        <div className="features_block">
                                          <div className="features-title">
                                            5 Minutes
                                          </div>
                                          <div className="features-description">
                                            Duration
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-129">
                                        <div className="faq-wrap">
                                          <img
                                            alt=""
                                            className="img-trg-2"
                                            src="images/62a9b652cf37c547ab973c50_5ea1c6b2c951644871c766a9_Untitled-1_162a9b652cf37c547ab973c50_5ea1c6b2c951644871c766a9_Untitled-1.png"
                                          />
                                        </div>
                                        <div className="features_block">
                                          <div className="features-title">
                                            Beginner
                                          </div>
                                          <div className="features-description">
                                            Level
                                          </div>
                                        </div>
                                        <div
                                          className="tooltip-trigger"
                                          data-w-id="49dff229-8248-0cdd-4b9a-7a9c37ff9ead"
                                        >
                                          <div className="tooltip">
                                            <div className="text-block-92">
                                              This is some{' '}
                                              <a className="text-link" href="#">
                                                text
                                              </a>{' '}
                                              inside of a div block.
                                            </div>
                                            <div className="tooltip-arrow"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-129">
                                        <div className="faq-wrap">
                                          <img
                                            alt=""
                                            className="img-trg-2"
                                            src="images/62a9b652cf37c5059c973c4a_w_162a9b652cf37c5059c973c4a_w.png"
                                          />
                                        </div>
                                        <div className="features_block">
                                          <div className="features-title">
                                            English
                                          </div>
                                          <div className="features-description">
                                            Language
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div className="cover-heading-black req-info">
                                        Request more info
                                      </div>
                                      <div className="button-row-homepage-2">
                                        <div className="form-block-5 w-form">
                                          <form
                                            data-name="Email Form"
                                            data-wf-element-id="49dff229-8248-0cdd-4b9a-7a9c37ff9ec0"
                                            data-wf-page-id="6596e21ac435cac3c66baaf0"
                                            id="email-form"
                                            method="get"
                                            name="email-form"
                                          >
                                            <input
                                              className="button-white hover text-input w-input"
                                              data-name="Email"
                                              id="email"
                                              maxLength={256}
                                              name="email"
                                              placeholder="you@example.com"
                                              type="text"
                                            />
                                          </form>
                                          <div className="w-form-done">
                                            <div>
                                              Thank you! Your submission has
                                              been received!
                                            </div>
                                          </div>
                                          <div className="w-form-fail">
                                            <div>
                                              Oops! Something went wrong while
                                              submitting the form.
                                            </div>
                                          </div>
                                        </div>
                                        <a
                                          className="button-blue-2 main-button hover w-button"
                                          href="#"
                                        >
                                          REQUEST INFO
                                          <br />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="right-col-copy">
                            <div className="div-block-128">
                              <div className="vid-header w-clearfix">
                                <div
                                  className="video w-video w-embed"
                                  style={{ paddingTop: '56.17021276595745%' }}
                                >
                                  <iframe
                                    allow="autoplay; fullscreen"
                                    allowfullscreen="true"
                                    className="embedly-embed"
                                    frameborder={0}
                                    scrolling="no"
                                    src="https://cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FrfscVS0vtbw%3Ffeature%3Doembed&amp;display_name=YouTube&amp;url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DrfscVS0vtbw&amp;image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FrfscVS0vtbw%2Fhqdefault.jpg&amp;key=96f1f04c5f4143bcb0f2e68c87d65feb&amp;type=text%2Fhtml&amp;schema=youtube"
                                    title="YouTube embed"
                                  ></iframe>
                                </div>
                                <a className="button w-button" href="#">
                                  ENROLL IN THIS COURSE
                                </a>
                              </div>
                              <div>
                                <div className="w-layout-grid features">
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/dol_1dol.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title price">
                                        $99
                                      </div>
                                      <div className="features-description">
                                        Price
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/prereq_1prereq.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title">
                                        Prerequisites
                                      </div>
                                      <div className="features-description">
                                        None
                                      </div>
                                    </div>
                                    <div
                                      className="tooltip-trigger"
                                      data-w-id="49dff229-8248-0cdd-4b9a-7a9c37ff9ee3"
                                    >
                                      <img
                                        alt=""
                                        className="image-61"
                                        src="images/tooltip-044cf9b8306c9cfaedd10c052f68998284deab5d7026612b2441c5376afafff2.svg"
                                      />
                                      <div className="tooltip">
                                        <div className="text-block-92">
                                          This is some{' '}
                                          <a className="text-link" href="#">
                                            text
                                          </a>{' '}
                                          inside of a div block.
                                        </div>
                                        <div className="tooltip-arrow"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        sizes="100vw"
                                        src="images/clock_2.png"
                                        srcset="images/clock_2-p-500.png 500w, images/clock_2.png 512w"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title">
                                        4 Weeks
                                      </div>
                                      <div className="features-description">
                                        Estimated Time
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/gl_1gl.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title">
                                        English
                                      </div>
                                      <div className="features-description">
                                        Language
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/cal-copy_1cal-copy.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title">
                                        September 2021
                                      </div>
                                      <div className="features-description">
                                        Enroll By
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/cer_1cer.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title cent-feat">
                                        Certificate
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/bars_1bars.png"
                                      />
                                    </div>
                                    <div className="features_block">
                                      <div className="features-title">
                                        Beginner
                                      </div>
                                      <div className="features-description">
                                        Level
                                      </div>
                                    </div>
                                    <div
                                      className="tooltip-trigger"
                                      data-w-id="49dff229-8248-0cdd-4b9a-7a9c37ff9f12"
                                    >
                                      <img
                                        alt=""
                                        className="image-61"
                                        src="images/tooltip-044cf9b8306c9cfaedd10c052f68998284deab5d7026612b2441c5376afafff2.svg"
                                      />
                                      <div className="tooltip">
                                        <div className="text-block-92">
                                          This is some{' '}
                                          <a className="text-link" href="#">
                                            text
                                          </a>{' '}
                                          inside of a div block.
                                        </div>
                                        <div className="tooltip-arrow"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-129">
                                    <div className="faq-wrap">
                                      <img
                                        alt=""
                                        className="img-trg-2"
                                        src="images/mod_1mod.png"
                                      />
                                    </div>
                                    <div className="features-title">
                                      Syllabus | Outline
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className="cover-heading-black req-info">
                                    Request more info
                                  </div>
                                  <div className="button-row-homepage-2">
                                    <div className="w-form">
                                      <form
                                        data-name="Email Form"
                                        data-wf-element-id="49dff229-8248-0cdd-4b9a-7a9c37ff9f25"
                                        data-wf-page-id="6596e21ac435cac3c66baaf0"
                                        id="email-form"
                                        method="get"
                                        name="email-form"
                                      >
                                        <input
                                          className="button-white hover text-input w-input"
                                          data-name="Email 2"
                                          id="email-2"
                                          maxLength={256}
                                          name="email-2"
                                          placeholder="you@example.com"
                                          type="text"
                                        />
                                      </form>
                                      <div className="w-form-done">
                                        <div>
                                          Thank you! Your submission has been
                                          received!
                                        </div>
                                      </div>
                                      <div className="w-form-fail">
                                        <div>
                                          Oops! Something went wrong while
                                          submitting the form.
                                        </div>
                                      </div>
                                    </div>
                                    <a
                                      className="button-blue-2 main-button hover w-button"
                                      href="#"
                                    >
                                      REQUEST INFO
                                      <br />
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div className="cover-heading-black feedback">
                                  Student Feedback
                                </div>
                                <div>
                                  <div
                                    className="slider-4 w-slider"
                                    data-animation="slide"
                                    data-autoplay="false"
                                    data-autoplay-limit={0}
                                    data-delay={4000}
                                    data-disable-swipe="false"
                                    data-duration={500}
                                    data-easing="ease"
                                    data-hide-arrows="false"
                                    data-infinite="true"
                                    data-nav-spacing={3}
                                  >
                                    <div className="w-slider-mask">
                                      <div className="w-slide">
                                        <div className="div-block-127">
                                          <div className="div-block-139 test-block">
                                            <div className="image_author">
                                              <img
                                                alt=""
                                                className="image-58"
                                                src="images/girl-657753_640.jpg"
                                              />
                                              <div className="test-name">
                                                Jayme Rose
                                              </div>
                                            </div>
                                            <div className="test-text">
                                              <div className="text-block-90">
                                                "Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam,
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="w-slide">
                                        <div className="div-block-127">
                                          <div className="div-block-139 test-block">
                                            <div className="image_author">
                                              <img
                                                alt=""
                                                className="image-58"
                                                src="images/girl-657753_640.jpg"
                                              />
                                              <div className="test-name">
                                                Jayme Rose
                                              </div>
                                            </div>
                                            <div className="test-text">
                                              <div className="text-block-90">
                                                "Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam,
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="left-arrow-2 w-slider-arrow-left">
                                      <div className="w-icon-slider-left"></div>
                                      <img
                                        alt=""
                                        className="image-60"
                                        src="https://uploads-ssl.webflow.com/5eb952f0f5ff0d26fd2e7261/5eb952f0f5ff0de71f2e7292_back.svg"
                                      />
                                    </div>
                                    <div className="right-arrow-2 w-slider-arrow-right">
                                      <div className="w-icon-slider-right"></div>
                                      <img
                                        alt=""
                                        className="image-ra"
                                        src="https://uploads-ssl.webflow.com/5eb952f0f5ff0d26fd2e7261/5eb952f0f5ff0d8cde2e7293_next.svg"
                                      />
                                    </div>
                                    <div className="slide-nav-5 w-slider-nav w-round"></div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div className="cover-heading-black rel-courses">
                                  Related Courses
                                </div>
                                <div>
                                  <div className="related-courses">
                                    <img
                                      alt=""
                                      className="image-62"
                                      sizes="100vw"
                                      src="images/5eb952f0f5ff0d982b2e72e6_c2.jpg"
                                      srcset="images/5eb952f0f5ff0d982b2e72e6_c2-p-500.jpeg 500w, images/5eb952f0f5ff0d982b2e72e6_c2.jpg 700w"
                                    />
                                    <div className="rel-course-text">
                                      <div className="text-block-82">
                                        Intro to Machine Learning with PyTorch
                                        <br />
                                      </div>
                                      <div className="rel-course-aut">
                                        Devante Carson
                                        <br />
                                        <br />
                                      </div>
                                      <div className="text-block-87">
                                        $99
                                        <br />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="related-courses">
                                    <img
                                      alt=""
                                      className="image-62"
                                      sizes="100vw"
                                      src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                      srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                                    />
                                    <div className="rel-course-text">
                                      <div className="text-block-82">
                                        Data Structures and Algorithms
                                        <br />
                                      </div>
                                      <div className="rel-course-aut">
                                        Sherry Mill
                                        <br />
                                        <br />
                                      </div>
                                      <div className="text-block-87">
                                        $99
                                        <br />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="related-courses">
                                    <img
                                      alt=""
                                      className="image-62"
                                      sizes="100vw"
                                      src="images/shutterstock_158522279.jpg"
                                      srcset="images/shutterstock_158522279-p-500.jpeg 500w, images/shutterstock_158522279.jpg 700w"
                                    />
                                    <div className="rel-course-text">
                                      <div className="text-block-82">
                                        Activation and Retention Strategy
                                        <br />
                                      </div>
                                      <div className="rel-course-aut">
                                        Jack Robinson
                                        <br />
                                        <br />
                                      </div>
                                      <div className="text-block-87">
                                        $99
                                        <br />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="about-menu">
                        <div className="profile_menu">
                          <a className="link-3 first active" href="#about">
                            About
                          </a>
                          <a className="link-3" href="#reviews">
                            Reviews
                          </a>
                          <a className="link-3" href="#instructors">
                            Instructors
                          </a>
                          <a className="link-3" href="#fa">
                            FAQ
                          </a>
                        </div>
                      </div>
                      <div className="page-body">
                        <div className="container">
                          <div className="div-block-134">
                            <div className="about" id="about">
                              <div className="text1">
                                This video covers foundational data science
                                tools and techniques, including getting,
                                cleaning, and exploring data, programming in
                                Python, and conducting reproducible research.
                                <br />
                              </div>
                              <div className="faq-question-wrap"></div>
                              <div>
                                <div className="div-block-141">
                                  <div className="text-block-91">
                                    WHAT YOU WILL LEARN
                                  </div>
                                  <div className="outcome">
                                    <div className="first">
                                      <div className="outcome-row">
                                        <div className="img">
                                          <img
                                            alt=""
                                            className="image-64"
                                            src="images/62a334c5a2b21b57f6ac43fe_checked_162a334c5a2b21b57f6ac43fe_checked.png"
                                          />
                                        </div>
                                        <div className="outcome-value">
                                          <div className="text-block-86">
                                            Use Python to clean, analyze and
                                            visualize data.
                                          </div>
                                        </div>
                                      </div>
                                      <div className="outcome-row">
                                        <div className="img">
                                          <img
                                            alt=""
                                            className="image-64"
                                            src="images/62a334c5a2b21b57f6ac43fe_checked_162a334c5a2b21b57f6ac43fe_checked.png"
                                          />
                                        </div>
                                        <div className="outcome-value">
                                          <div className="text-block-86">
                                            Use GitHub to manage data science
                                            projects.
                                            <br />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="second">
                                      <div className="outcome-row">
                                        <div className="img">
                                          <img
                                            alt=""
                                            className="image-64"
                                            src="images/62a334c5a2b21b57f6ac43fe_checked_162a334c5a2b21b57f6ac43fe_checked.png"
                                          />
                                        </div>
                                        <div className="outcome-value">
                                          <div className="text-block-86">
                                            Learn how to ask the right
                                            questions, obtain data,
                                          </div>
                                        </div>
                                      </div>
                                      <div className="outcome-row">
                                        <div className="img">
                                          <img
                                            alt=""
                                            className="image-64"
                                            src="images/62a334c5a2b21b57f6ac43fe_checked_162a334c5a2b21b57f6ac43fe_checked.png"
                                          />
                                        </div>
                                        <div className="outcome-value">
                                          <div className="text-block-86">
                                            Set up Python, Github and other
                                            useful tools
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="skills">
                                    <div className="text-block-91">
                                      SKILLS YOU WILL GAIN
                                    </div>
                                    <div className="outcome-copy">
                                      <a
                                        className="link-block-3 w-inline-block"
                                        href="#"
                                      >
                                        <div className="skill-div">
                                          <div className="text-block-93">
                                            Python
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-3 w-inline-block"
                                        href="#"
                                      >
                                        <div className="skill-div">
                                          <div className="text-block-93">
                                            Machine Learning
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-3 w-inline-block"
                                        href="#"
                                      >
                                        <div className="skill-div">
                                          <div className="text-block-93">
                                            Github
                                          </div>
                                        </div>
                                      </a>
                                      <a
                                        className="link-block-3 w-inline-block"
                                        href="#"
                                      >
                                        <div className="skill-div">
                                          <div className="text-block-93">
                                            Exploratory Data Analysis
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="testimonials" id="reviews">
                            <div className="wr">
                              <div
                                className="slider-5 w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="false"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="w-slider-mask">
                                  <div className="w-slide">
                                    <div className="div-block-131">
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Jayme Rose
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "I like the possibility of getting
                                            new knowledge for such affordable
                                            prices. Also, great selection of
                                            different topics"
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Alany Byrd
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "I've bought a number of courses the
                                            last few years and they've been
                                            excellent. Great tutors, great
                                            content and great prices."
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Tianna Croft
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "This is one of the best online
                                            courses  ever. It contains a lot of
                                            courses in every single field. I
                                            highly recommend it"
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="w-slide">
                                    <div className="div-block-131">
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Jayme Rose
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "I like the possibility of getting
                                            new knowledge for such affordable
                                            prices. Also, great selection of
                                            different topics"
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Alany Byrd
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "I've bought a number of courses the
                                            last few years and they've been
                                            excellent. Great tutors, great
                                            content and great prices."
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Tianna Croft
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "This is one of the best online
                                            courses  ever. It contains a lot of
                                            courses in every single field. I
                                            highly recommend it"
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow-2 w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-71"
                                    loading="lazy"
                                    src="images/back-6.png"
                                  />
                                </div>
                                <div className="right-arrow-2 w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-71"
                                    loading="lazy"
                                    src="images/next-5.png"
                                  />
                                </div>
                                <div className="slide-nav-2 w-slider-nav w-round"></div>
                              </div>
                              <div
                                className="slider-5 mob w-slider"
                                data-animation="slide"
                                data-autoplay="false"
                                data-autoplay-limit={0}
                                data-delay={4000}
                                data-disable-swipe="false"
                                data-duration={500}
                                data-easing="ease"
                                data-hide-arrows="false"
                                data-infinite="true"
                                data-nav-spacing={3}
                              >
                                <div className="w-slider-mask">
                                  <div className="w-slide">
                                    <div className="div-block-131">
                                      <div className="div-block-139 test-block ns">
                                        <div className="image_author-2">
                                          <img
                                            alt=""
                                            className="image-58"
                                            src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                          />
                                          <div className="test-name-2">
                                            Jayme Rose
                                          </div>
                                        </div>
                                        <div className="test-text-2">
                                          <div className="text-block-86">
                                            "I like the possibility of getting
                                            new knowledge for such affordable
                                            prices. Also, great selection of
                                            different topics"
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="left-arrow-2 w-slider-arrow-left">
                                  <img
                                    alt=""
                                    className="image-71"
                                    loading="lazy"
                                    src="images/back-6.png"
                                  />
                                </div>
                                <div className="right-arrow-2 w-slider-arrow-right">
                                  <img
                                    alt=""
                                    className="image-71"
                                    loading="lazy"
                                    src="images/next-5.png"
                                  />
                                </div>
                                <div className="slide-nav-2 w-slider-nav w-round"></div>
                              </div>
                            </div>
                          </div>
                          <div className="instructors" id="instructors">
                            <div className="heading">Instructors</div>
                            <div className="instructor-cont">
                              <div className="instuctor-column-left">
                                <div className="inst-col">
                                  <div className="instructor-block">
                                    <div className="inst-block">
                                      <img
                                        alt=""
                                        className="instructor-img"
                                        sizes="(max-width: 479px) 70px, 100px"
                                        src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                        srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                                      />
                                      <div className="div-block-140">
                                        <div className="instructor-name">
                                          Ann-Marie Rice, Phd
                                        </div>
                                        <div className="instructor-subtitle">
                                          Computer Science Professor
                                        </div>
                                        <div className="instructor-school">
                                          School of Computer Science
                                        </div>
                                      </div>
                                    </div>
                                    <div className="inst-block">
                                      <img
                                        alt=""
                                        className="instructor-img"
                                        src="images/t6.jpg"
                                      />
                                      <div className="div-block-140">
                                        <div className="instructor-name">
                                          Mary Cobb
                                        </div>
                                        <div className="instructor-subtitle">
                                          Computer Science Professor
                                        </div>
                                        <div className="instructor-school">
                                          School of Computer Science
                                        </div>
                                      </div>
                                    </div>
                                    <div className="inst-block">
                                      <img
                                        alt=""
                                        className="instructor-img"
                                        src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                      />
                                      <div className="div-block-140">
                                        <div className="instructor-name">
                                          Danyl Cano
                                        </div>
                                        <div className="instructor-subtitle">
                                          Computer Science Professor
                                        </div>
                                        <div className="instructor-school">
                                          School of Computer Science
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="faq" id="faq">
                            <div className="div-block-124">
                              <div className="heading" id="fa">
                                Frequently Asked Questions
                              </div>
                              <div className="div-block-135">
                                <div
                                  className="accordion js-accordion"
                                  data-ix="fade-up-1"
                                >
                                  <div className="accordion-item">
                                    <div
                                      className="accordion__title__faq"
                                      data-w-id="49dff229-8248-0cdd-4b9a-7a9c37ffa123"
                                    >
                                      <div className="accordion__plus-wrapper-faq">
                                        <img
                                          alt=""
                                          className="image-70"
                                          src="images/chevron_1chevron.png"
                                        />
                                      </div>
                                      <div className="text-block-89">
                                        When will I have access to the lectures
                                        and assignments?
                                      </div>
                                    </div>
                                    <div
                                      className="accordion__content-wrap"
                                      style={{ height: '0PX' }}
                                    >
                                      <div className="accordion__content_faq">
                                        <div className="faq__block">
                                          <div className="div-block-40-faq">
                                            <div className="text-block-86">
                                              Once you enroll for a Certificate,
                                              you’ll have access to all videos,
                                              quizzes, and programming
                                              assignments (if applicable). Peer
                                              review assignments can only be
                                              submitted and reviewed once your
                                              session has begun. If you choose
                                              to explore the course without
                                              purchasing, you may not be able to
                                              access certain assignments.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <div
                                      className="accordion__title__faq"
                                      data-w-id="49dff229-8248-0cdd-4b9a-7a9c37ffa12f"
                                    >
                                      <div className="accordion__plus-wrapper-faq">
                                        <img
                                          alt=""
                                          className="image-70"
                                          src="images/chevron_1chevron.png"
                                        />
                                      </div>
                                      <div className="text-block-89">
                                        What will I get if I subscribe to this
                                        Specialization?
                                      </div>
                                    </div>
                                    <div
                                      className="accordion__content-wrap"
                                      style={{ height: '0PX' }}
                                    >
                                      <div className="accordion__content_faq">
                                        <div className="faq__block">
                                          <div className="div-block-40-faq">
                                            <div className="text-block-86">
                                              When you enroll in the course, you
                                              get access to all of the courses
                                              in the Specialization, and you
                                              earn a certificate when you
                                              complete the work. Your electronic
                                              Certificate will be added to your
                                              Accomplishments page - from there,
                                              you can print your Certificate or
                                              add it to your LinkedIn profile.
                                              If you only want to read and view
                                              the course content, you can audit
                                              the course for free.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default VideoView;

/* eslint-enable */
